import {Component, Inject, Input, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss']
})
export class PromptComponent {

  isMobile = null
  isOnboarding = null

  @Input() mobileType: 'ios' | 'android';
  @Input() promptEvent?: any;

  constructor(
    private activeModal: NgbActiveModal,
    private route: ActivatedRoute,
    private router: Router,
    /*@Inject(MAT_BOTTOM_SHEET_DATA) public data: { mobileType: 'ios' | 'android', promptEvent?: any },
    private bottomSheetRef: MatBottomSheetRef<PromptComponent>*/
  ) 
  {

    this.route.queryParams.subscribe((params)=>{
      if(params['isMobile']) {
        this.isMobile = true
      }
    })  

  }

  ngOnInit() {

    const self = this

    if(this.router.url == "/page/personal/first-onboarding"){
     this.isOnboarding = true
    }   
  }

  async installPwa(): Promise<void> {
    await this.promptEvent.prompt();
    const { outcome } = await this.promptEvent.userChoice;

    if (outcome)
      this.close("APP instalado com sucesso!");
    else
      this.close("O APP não foi instalado!");
  }

  close(reason: string) {
    this.activeModal.dismiss(reason);
  }

  /*constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { mobileType: 'ios' | 'android', promptEvent?: any },
    private bottomSheetRef: MatBottomSheetRef<PromptComponent>
  ) {}

  public installPwa(): void {
    this.data.promptEvent.prompt();
    this.close();
  }

  public close() {
    this.bottomSheetRef.dismiss();
  }*/

}
